import { DirectionToText } from "./direction";
import { DateToText } from "./date";

async function GetLastItems(e) {
  let result = {};
  let length = "";
  for (let key in e) {
    switch (e[key].type) {
      case "windspeed":
        length = e[key].values.s.length;
        result[e[key].type] = { s: e[key].values.s[length - 1] > 0.2 ? e[key].values.s[length - 1] : 0, r: e[key].values.r[length - 1], time: DateToText(e[key].time[length - 1]) };
        break;
      case "winddirect":
        if (e[key].values[0] != undefined) {
          length = e[key].values[0].length;
          result[e[key].type] = [e[key].values[0][length - 1], DirectionToText(e[key].values[0][length - 1])];
        } else {
          result[e[key].type] = -1;
        }
        break;
      case "winddirectcard":
        length = 0;
        result[e[key].type] = 0;
        break;
      default:
        length = e[key].values.length;
        result[e[key].type] = e[key].values[length - 1];
        break;
    }
  }
  return result;
}

/* Получить Первый элемент */
async function GetFirstItems(e) {
  const result = [];
  for (let key in e) {
    switch (e[key].type) {
      case "windspeed":
        result.push({ name: e[key].name, value: e[key].values.s[0], time: e[key].time[0] });
        break;
      case "winddirect":
        result.push({ name: e[key].name, value: DirectionToText(e[key].values[0][0]), time: e[key].time[0] });
        break;
      default:
        result.push({ name: e[key].name, value: e[key].values[0], time: e[key].time[0] });
    }
  }
  return result;
}

export { GetLastItems, GetFirstItems };
